<h1 mat-dialog-title>EBB Retrofit Project</h1>
<div mat-dialog-content>
  <div *ngIf="data else showRejectionMessage">
    <h6>Congratulations!</h6>
    <p>
      You have a new EBB Retrofit Project.
    </p>
    <p>
      You have agreed to upload necessary documents on behalf of the Homeowner:
    </p>
    <ol>
      <li>Permit # & Application</li>
      <li>House Photos</li>
      <li>Receipts / Invoices</li>
    </ol>
    <p>
      Please <a routerLink="/contact">contact us</a> if you have any questions.
    </p>
  </div>
  <ng-template #showRejectionMessage>
    <p>
      You have declined the responsibility to upload documents on behalf of the Homeowner.
    </p>
    <p>
      Please <a routerLink="/contact">contact us</a> if you have any questions.
    </p>
  </ng-template>

</div>
<div mat-dialog-actions style="margin-top: 9px !important; float: right !important;">
  <button mat-button 
    (click)="onClickCancel()">
    CANCEL
  </button>
  <button mat-flat-button color="primary" style="margin-left: 6px;"
    (click)="onClickConfirm()">
    CONFIRM
  </button>
</div>
